import { Archive, BarChart3, BookOpen, CalendarDays, Dumbbell, UserRound } from 'lucide-react'
import { Brand } from './Brand.jsx'

const mainLinks = [
  { path: '/', label: "Aujourd'hui", icon: CalendarDays },
  { path: '/entrainement', label: 'Entraînement', icon: Dumbbell },
  { path: '/classement', label: 'Classement', icon: BarChart3 },
  { path: '/archives', label: 'Archives', icon: Archive },
]

function NavLink({ path, label, icon: Icon, route, navigate, mobile = false }) {
  const active = path === '/' ? route === '/' || route.startsWith('/jouer/quotidien') : route.startsWith(path)
  return (
    <button
      type="button"
      className={`${mobile ? 'bottom-nav-link' : 'nav-link'} ${active ? 'is-active' : ''}`}
      onClick={() => navigate(path)}
      aria-current={active ? 'page' : undefined}
    >
      {Icon && <Icon size={mobile ? 21 : 17} strokeWidth={2} />}
      <span>{label}</span>
    </button>
  )
}

export function Header({ route, navigate, nickname, onProfile }) {
  return (
    <header className="site-header">
      <button type="button" className="brand-button" onClick={() => navigate('/')} aria-label="Accueil Sukoji">
        <Brand />
      </button>
      <nav className="desktop-nav" aria-label="Navigation principale">
        {mainLinks.map((link) => (
          <NavLink key={link.path} {...link} route={route} navigate={navigate} />
        ))}
        <NavLink path="/regles" label="Règles" icon={BookOpen} route={route} navigate={navigate} />
      </nav>
      <button type="button" className="profile-chip" onClick={onProfile} aria-label="Ouvrir mon profil">
        <span>{nickname || 'Mon profil'}</span>
        <span className="avatar"><UserRound size={17} /></span>
      </button>
    </header>
  )
}

export function BottomNavigation({ route, navigate }) {
  return (
    <nav className="bottom-nav" aria-label="Navigation mobile">
      {mainLinks.map((link) => (
        <NavLink key={link.path} {...link} route={route} navigate={navigate} mobile />
      ))}
    </nav>
  )
}
